import React from "react";
import { Row, Col } from "react-bootstrap";
import { GLBANOTICELINK } from 'Utils/Constants';

import "./Footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <Row>
        <Col>
          <a rel="noreferrer" target="_blank" href="https://www.vippreferred.com/privacy-policy">Privacy Notice</a> | <a rel="noreferrer" target="_blank" href={GLBANOTICELINK}>GLBA Notice</a>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;